export const isEnterKey = (e: KeyboardEvent | React.KeyboardEvent): boolean => {
  return e.key === 'Enter';
};
